"use client";

import { useAtomValue } from "jotai";
import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { DevicesThemeList, DevicesSidebarFilterTag } from "@/components";
import { observatoriesCountAtom } from "@/store/devices";
import { ThemeLegend, ThemeTypeEnum } from "@/types";

function DevicesSidebar(): ReactElement {
  const t = {
    theme: useTranslations("global.Theme"),
    sidebar: useTranslations("devices.Sidebar"),
  };

  const counters = useAtomValue(observatoriesCountAtom);

  const themes: ThemeLegend[] = [
    {
      label: t.theme("earth"),
      type: ThemeTypeEnum.EARTH,
      count: counters.byTheme[ThemeTypeEnum.EARTH],
    },
    {
      label: t.theme("water"),
      type: ThemeTypeEnum.WATER,
      count: counters.byTheme[ThemeTypeEnum.WATER],
    },
    {
      label: t.theme("universe"),
      type: ThemeTypeEnum.UNIVERSE,
      count: counters.byTheme[ThemeTypeEnum.UNIVERSE],
    },
    {
      label: t.theme("biodiversity"),
      type: ThemeTypeEnum.BIODIVERSITY,
      count: counters.byTheme[ThemeTypeEnum.BIODIVERSITY],
    },
  ];

  return (
    <div className="sticky top-12 bottom-0">
      <div className="pt-2">
        <header className="relative flex flex-row gap-2 items-center justify-between p-3 m-0">
          <div className="flex flex-row items-center">
            <span className="text-lg">{counters.total}</span>
            &nbsp;
            {t.sidebar("deviceCounter", { count: counters.total })}
          </div>
        </header>
        <div className="p-3 m-0 flex flex-col gap-6">
          <div className="p-0 m-0">
            <DevicesThemeList themes={themes} />
          </div>
          <div className="flex flex-col gap-1.5 p-0 m-0">
            <h4 className="uppercase text-xs font-semibold text-foreground! p-0 h-auto mb-1">
              {t.sidebar("search")}
            </h4>
            <DevicesSidebarFilterTag />
          </div>
        </div>
      </div>
    </div>
  );
}

export { DevicesSidebar };
